import React, { useEffect, useState } from 'react'
import { useHistory } from "react-router-dom";
import { connect, useDispatch, useSelector } from 'react-redux'
import { clearRoom, getRoom, reportUser } from '../../actions/userActions'
import inMemoryJWT from '../../auth/inMemoryJwt';
import socketLogic from '../../sockets/sockets';
import { urlServer } from '../../config/GlobalConstant'
import { getConversationRoom, addMessageRoom } from "../../actions/messagesActions";
import { seeMyRooms, seeRoomsIBelong, getMembersRoom } from '../../actions/userActions';
import ChatCardMessage from '../../containers/Chat/Message/ChatCardMessage';
import ChatInput from '../../containers/Chat/ChatInput';
import useModal from '../../utils/hooks/useModal';
import ModalReportPost from '../../containers/ReportContent/ModalReportPost';
import localStorage from '../../utils/hooks/useLocalStorage';


const SeeRoom = ({
    userToReport,
    setUserToReport,
    refReport,
    isShowReport,
    setIsShowReport,
    userReported, match, clearRoom, membersRoom, getConversationRoom, conversation, isLoadingConversation, roomInfo, addMessageRoom }) => {
    const history = useHistory()

    const { userInfo } = useSelector(state => state.userInfo)


    useEffect(() => {
        if (!(inMemoryJWT.getToken())) {
            inMemoryJWT.getRefreshedToken()
        }
        inMemoryJWT.waitForTokenRefresh().then(() => {
            //  getRoom(match.params.idRoom)
            getConversationRoom(match.params.idRoom)
            //  getMembersRoom(match.params.idRoom)

        })
        return () => {
            clearRoom()
        }
      
        // console.log();
    }, [match.params.idRoom]);

    useEffect(() => { 

        if (roomInfo.members) {
            console.log();
            if (roomInfo.adminID !== localStorage().getItem('idUser') && roomInfo.members.filter(member => member ===localStorage().getItem('idUser')).length === 0) {
                console.log();
                //   history.push(`/Rooms/join/${match.params.idRoom}`)
            }

        }


    }, [roomInfo._id]);

    useEffect(() => {

        if (roomInfo.lenght) {
            history.push(`/Rooms`)
        }
        if (roomInfo.socketIDRoom) {

            socketLogic.joinRoom(roomInfo.socketIDRoom);
        }
        return () => {
            if (roomInfo.socketIDRoom) {
                socketLogic.removeListener("private-message-room")
                socketLogic.leaveRoom(roomInfo.socketIDRoom);
            }

        }

    }, [match.params.idRoom, roomInfo.socketIDRoom]);
    useEffect(() => {
        return () => {
            socketLogic.removeListener("private-message-room")
        }
    }, [])


    useEffect(() => {

        socketLogic.listenAllEvents('private-message-room', res => {
            console.log();
            if (res.id != localStorage().getItem("idProfile")) {
                if (res.bodyMessage.senderID) {
                    addMessageRoom(res.bodyMessage)
                }
            }
        });
    }, []);





    const [replyMenssage, setReplyMenssage] = useState(null)











    const handleNewUserMessage = async (dataFiles, sendMessage, clear) => {
        const formData = new FormData();
        Object.values(dataFiles).map((dataFile) => {
            formData.append('files', dataFile.file)
        })
        formData.append('content', sendMessage)
        { replyMenssage && formData.append('responseToMessageId', `${replyMenssage._id}`) }


        let id = localStorage().getItem('idUser')
        if (userInfo.franchiseID) {
            if (userInfo.franchiseID.state ===2) {
                if (localStorage().getItem('typeProfile') != "user") {
                    id = userInfo.franchiseID._id
                }

            }
        }

      //  formData.append('senderID', id)
        formData.append('addresseeID', match.params.idRoom)
       formData.append('roomSocketId', roomInfo.socketIDRoom)
       // formData.append('stateMessage', 1);

        console.log();

        await fetch(`${urlServer}chats/send-message-room`, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            headers: {
                //'Access-Control-Allow-Origin': '*'
                //'Content-Type': 'application/json',
                // 'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': `bearer ${inMemoryJWT.getToken()}`
            },
            body: formData
        })
            .then(response => response.json())
            .then(respJson => {
                console.log()
                       addMessageRoom(respJson.data)
                clear()
            })
            .catch(error => {
                console.log()
            })
        // Now send the message throught the backend API
    }

    let id = localStorage().getItem('idProfile')
  

    return (
        <div className="column">
            <div className="container-rooms-chats">
                <div className="navbar-room-info">
                    <div className="column">
                        <div className="img-room-rooms">

                        </div>

                    </div>
                </div>
                <div className={`container-message-room  scroll-menu`}>
                    <div className="content-message-between">
                        {!isLoadingConversation && conversation.map(message => {
                            let src = null
                            if(message.senderType ==="user"){
                                src = message.senderUserId.picture && message.senderUserId.picture.url && message.senderUserId.picture.url.small
                            }
                            if(message.senderType ==="franchise"){
                                src = message.senderFranchiseId.picture && message.senderFranchiseId.picture.url && message.senderFranchiseId.picture.url.small
                            }
                            if(message.senderType ==="representative"){
                                src = message.senderRepresentativeId.userID.picture && message.senderRepresentativeId.userID.picture.url && message.senderRepresentativeId.userID.picture.url.small
                            }
                            if(message.senderType ==="warehouse"){
                                src = message.senderWarehouseId.profileId.picture && message.senderWarehouseId.profileId.picture.url && message.senderWarehouseId.profileId.picture.url.small
                            }
                           
                            return (
                                <ChatCardMessage
                                    key={message._id}
                                    reportUser={() => {
                                        setUserToReport(message.infoSender)
                                        setIsShowReport(true)
                                    }} message={message} replyMenssage={replyMenssage} setReplyMenssage={setReplyMenssage}

                                    isSelf={message.senderID === id}

                                    idUser={localStorage().getItem('idUser')}
                                    srcImage={src} />
                            )

                        })}
                        <ModalReportPost
                            closeModal={() => {
                                setIsShowReport(false)
                                setUserToReport(null)
                            }}
                            displayModal={isShowReport}
                            communityID={roomInfo._id}
                            idReported={userToReport?._id}
                            reportType="userChat"
                        />
                    </div>
                </div>
                <ChatInput replyMenssage={replyMenssage} setReplyMenssage={setReplyMenssage} handleNewUserMessage={handleNewUserMessage} />
            </div>
        </div >
    )
}

const mapStateToProps = (state) => {
    return {
        //  isLoadingMembersRoom: state.userInfo.isLoadingMembersRoom,
        //   membersRoom: state.userInfo.membersRoom,
        //   roomInfo: state.userInfo.roomInfo,
        conversation: state.messages.conversationRoom,
        isLoadingConversation: state.messages.isLoadingConversationRoom,
    }
}


export default connect(mapStateToProps, { clearRoom, getRoom, getConversationRoom, addMessageRoom, getMembersRoom, seeRoomsIBelong, seeMyRooms })(SeeRoom)